import { memo } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { Panel } from "primereact/panel";
import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useReport } from "../../context/report";
 
export default memo(function QuebrasCemMil() {
    const { data, handlePrint, printing } = useReport();

    const format = (rowData, rowIndex) => {
        return Intl.NumberFormat('pt-Br', { maximumFractionDigits: 2 }).format(rowData[rowIndex.field]);
    }

    const options = {
        maintainAspectRatio: false, plugins: {
            title: {
                display: true,
                text: 'Gráfico de Cem Mil Batidas por Turma - ' + data.periodo,
                font: {
                    size: 20
                }
            },
            datalabels: {
                font: {
                    size: 24
                },
                color: "#000",
            }
        },
        scales: {
            x: {
              ticks: {
                font: {
                  size: 16
                },
                color: "#000"
              }
            },
          }
    }

    const Table = () => {
        return (
            <Card title="Tabela de Cem Mil Batidas" subTitle={`${data.periodo}`}>
                <DataTable
                    id="table1"
                    stripedRows
                    value={data.producoes}
                >
                    <Column header="Tear" field="tear" sortable />
                    <Column header="Turma" field="turma" sortable />
                    <Column header="Dias" field="dias" sortable />
                    <Column header="Batidas" field="batidas" sortable />
                    <Column header="Total Quebras Trama" field="trama" body={format} style={{ width: '10%' }} sortable />
                    <Column header="Média Quebras Trama/Dia" field="media_trama_dia" body={format} style={{ width: '10%' }} sortable />
                    <Column header="Média Quebras Trama CMPX/Dia" field="media_trama_cmpx" body={format} style={{ width: '10%' }} sortable />
                    <Column header="Total Quebras Urdume" field="urdume" body={format} style={{ width: '10%' }} sortable />
                    <Column header="Média Quebras Urdume/Dia" field="media_urdume_dia" body={format} style={{ width: '10%' }} sortable />
                    <Column header="Média Quebras Urdume CMPX/Dia" field="media_urdume_cmpx" body={format} style={{ width: '10%' }} sortable />
                </DataTable>
            </Card>
        )
    };

    const ChartCmpx = ({ selected, index }) => {
        let labels = [];
        let trama = [];
        let urdume = [];

        selected.forEach(element => {
            labels.push([element.label, `Trama: ${element.media_trama_cmpx.toFixed(2)}`, `Urdume: ${element.media_urdume_cmpx.toFixed(2)}`]);
            trama.push(element.media_trama_cmpx.toFixed(2));
            urdume.push(element.media_urdume_cmpx.toFixed(2));
        });

        const chartData = {
            labels: labels,
            datasets: [
                {
                    label: 'Trama',
                    data: trama,
                    backgroundColor: '#3498db'
                },
                {
                    label: 'Urdume',
                    data: urdume,
                    backgroundColor: '#e74c3c'
                }
            ]
        }

        return (
            <Chart 
                id={`chartCemMil${index}`}
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                type="bar"
                data={chartData}
                plugins={[ChartDataLabels]}
                options={options}
            />
        )
    };

    return (
        <div>
            <Panel header="RELATÓRIO DE QUEBRAS POR CMPX POR TEAR" toggleable collapsed={true}>
                <Button className="p-m-2" icon="pi pi-print" onClick={() => handlePrint('table1')} />
                <Table />
            </Panel>
            <Panel header="RELATÓRIO DE QUEBRAS POR CMPX POR TURMA" toggleable collapsed={true}>
                <Button className="p-m-2" icon="pi pi-print" onClick={() => handlePrint('chartCemMil1')} />
                <ChartCmpx selected={data.turmas} index={1} />
            </Panel>
            <Panel header="RELATÓRIO DE QUEBRAS POR CMPX POR GRUPO DE MÁQUINAS" toggleable collapsed={true}>
                <Button className="p-m-2" icon="pi pi-print"  onClick={() => handlePrint('chartCemMil2')} />
                <ChartCmpx selected={data.grupos} index={2} />
            </Panel>
        </div>
    )
});